import { combineReducers } from "redux";
import { authReducer } from "./auth.reducer";
import { teamReducer } from "./team.reducer";
import { playerReducer } from "./player.reducer";
import { statusTrackerReducer } from "./statustracker.reducer";
import { breakdownReducer } from "./breakdown.reducer";
import { drillsReducer } from "./drills.reducer";
import { baselineReducer } from "./baseline.reducer";
import { compareReducer } from "./compare.reducer";
import { calendarReducer } from "./calendar.reducer";
import { managerReducer } from "./manager";
import { settingsReducer } from "./settings.reducer";

export default combineReducers({
  auth: authReducer,
  team: teamReducer,
  player: playerReducer,
  statusTracker: statusTrackerReducer,
  breakdown: breakdownReducer,
  drills: drillsReducer,
  baseline: baselineReducer,
  compare: compareReducer,
  calendar: calendarReducer,
  manager: managerReducer,
  settings: settingsReducer
});
